import * as Yup from "yup";

import { IField } from "../types";

/**
 * Create Yup string schema object.
 *
 * @author Miew
 * @see https://github.com/jquense/yup#string
 * @return {object} Yup validationSchema Object.
 */
export default class StringSchemaFactory {
  fieldData: IField;
  /**
   * Constructor.
   *
   * Note: wp-graphql-gravity-forms plugin may need to be replaced.
   *
   * @see https://github.com/harness-software/wp-graphql-gravity-forms
   * @param {object} fieldData from GravityForm GraphQL data Object.
   */
  constructor(fieldData: object) {
    this.fieldData = fieldData;
  }

  /**
   * Get Yup required field validaion.
   *
   * @see https://github.com/jquense/yup#stringemailmessage-string--function-schema
   * @return {object} Yup validationSchema Object.
   */
  getEmailSchema() {
    if (this.fieldData?.type !== "email") {
      return;
    }

    return Yup.string().email(`Deve ser um email válido.`);
  }

  /**
   * Get Yup max line length validation.
   *
   * @see https://github.com/jquense/yup#stringmaxlimit-number--ref-message-string--function-schema
   * @return {object} Yup validationSchema Object.
   */
  getMaxLengthSchema() {
    if (!this.fieldData?.maxLength) {
      return;
    }

    return Yup.string().max(
      this.fieldData.maxLength,
      `Máximo de ${this.fieldData.maxLength} caracteres`
    );
  }

  /**
   * Get Yup required field validaion.
   *
   * @see https://github.com/jquense/yup#stringrequiredmessage-string--function-schema
   * @return {object} Yup validationSchema Object.
   */
  getRequiredSchema() {
    if (!this.fieldData?.isRequired) {
      return;
    }

    return Yup.string().required("Obrigatório!");
  }

  /**
   * Get Yup required field validaion.
   *
   * @see https://github.com/jquense/yup#stringurlmessage-string--function-schema
   * @return {object} Yup validationSchema Object.
   */
  getUrlSchema() {
    if (this.fieldData?.type !== "website") {
      return;
    }

    return Yup.string().url(`Insira um URL válido: "https://examplo.pt".`);
  }




  /**
 * Get Yup phone validation schema.
 * @return {object} Yup validationSchema Object.
 */

  getPhoneSchema() {
    if (this.fieldData?.type !== "phone") {
      return;
    }

    // Adjusted regex to allow optional +351 prefix and optional spaces within the number
    return Yup.string()
      .matches(/^\+351 9[1236][0-9]{7}$|^9[1236][0-9]{7}$/, {
        message: 'Número de telefone inválido. Deve seguir o formato "+351 910100200" ou "910100200".',
        excludeEmptyString: true,
      })
      .required('Telefone é obrigatório');


  }

  /**
   * Get Yup schema object with validation requirements.
   *
   * Combine multiple schemas into one.
   *
   * @see https://github.com/jquense/yup#mixedconcatschema-schema-schema
   * @return {object} Combined Yup validationSchema Object.
   */
  get schema() {
    return Yup.string()
      .concat(this.getEmailSchema() as any)
      .concat(this.getMaxLengthSchema() as any)
      .concat(this.getRequiredSchema() as any)
      .concat(this.getUrlSchema() as any)
      .concat(this.getPhoneSchema() as any)
      .nullable();
  }
}
